module.exports = __webpack_public_path__ + "static/media/dong.5f64e940.png";